import endpoints from './api-endpoint-definition.json';
import { EntityFilter } from '../../_models/taxonomy-filter/entity-filter';
import { ApiCall } from '@lcms/api-definition';

export type TopicFilterResponse = EntityFilter[]

const definition = new ApiCall<TopicFilterResponse>().get('topicFilter', { route: endpoints.topicFilter })
export default definition;